import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    HStack,
    Box,
    Text,
    Spacer,
    Stack,

} from '@chakra-ui/react'
import SraList from './SraList'
import moment from 'moment/moment'


export default function ScnDetails({ isOpen, onClose, singleData }) {


    console.log("singleDAta", singleData)
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>SCN Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={"20px"}>
                    <HStack>
                            <SraList title={"Product Name: "} details={singleData[0]?.shelfid.productname} />
                            <Spacer />
                            <SraList title={"Product ShelfId: "} details={singleData[0]?.shelfid.productshelfid} />
                        </HStack>
                        <HStack>
                            <SraList title={"Quantity Certified: "} details={singleData[0]?.qtycertified||"Awaiting I&QA"} />
                            <Spacer />
                            <SraList title={"Quantity Returned: "} details={singleData[0]?.qtyreturned} />
                        </HStack>
                        <HStack>
                            <SraList title={"Serviceable: "} details={singleData[0]?.serviceable||"Awaiting I&QA"} />
                            <Spacer />
                            <SraList title={"Unserviceable: "} details={singleData[0]?.unserviceable||"Awaiting I&QA"} />
                        </HStack>
                       
                        <HStack>
                            <SraList title={"Status: "} details={singleData[0]?.status} />
                            <Spacer />
                            <SraList title={"Created At: "} details={moment(singleData[0]?.createdAt).format('DD/MM/YYYY')} />
                        </HStack>
                        <HStack>
                            <SraList title={"Returnee Department: "} details={singleData[0]?.returneedepartment} />
                            <Spacer />
                            <SraList title={"Price: "} details={singleData[0]?.price} />
                        </HStack>
                        <SraList title={"Return by: "} details={singleData[0]?.returnby} />

                       
                       
                      
                     

                    




                    </Stack>

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
